import axios from "axios";
import {BACK_OFFICE_API, ORDER_API, POS_API} from "../constants/apiUrls";


// 주문 채널 관리자 상점 조회 API
export const getAdminShopInfoApi = async (shopId) => {
  const response = await axios.get(`${ORDER_API}/shop/detail/admin/${shopId}`);
  return response.data;
}

// 하위 상점 조회
export const getDownShopListApi = async (userType, userId, shopId) => {
  let getShopList;
  let getShopId;
  let getShopName;

  if (userType === 4) {
    const shopInfo = await axios.get(`${BACK_OFFICE_API}/shop/${userId}`);
    const shopData = shopInfo.data[0];
    getShopList = [{
      id: shopData.id,
      storeName: shopData.shopName,
      serviceType: shopData.serviceTpcd,
      status: shopData.statusTpcd,
      loginId: shopData.loginId,
      createTs: shopData.createTs,
      approvalTpcd1: shopData.approvalTpcd1,
      approvalTpcd2: shopData.approvalTpcd2
    }];
  } else {
    const shopInfo = await axios.get(`${BACK_OFFICE_API}/shop/downShopList`, {
      params: {
        chanlTpcd: 2,
        topShopId: userId
      }
    });
    getShopList = shopInfo.data;
  }

  if (shopId === null) {
    getShopId = getShopList[0].id;
    getShopName = getShopList[0].storeName;
  } else {
    for(let i = 0; getShopList.length > i; i++) {
      if (Number(shopId) === getShopList[i].id) {
        getShopId = getShopList[i].id;
        getShopName = getShopList[i].storeName;
      }
    }
  }

  return { shopId: getShopId, shopName: getShopName, shopList: getShopList };
}

// 주문채널 상점 수정
export const setOrderShopApi = async (shopId, data) => {
  await axios.put(`${ORDER_API}/shop/v2/${shopId}`, data);
}

// 주문채널 상점 기본정보 조회
export const getOrderShopInfoApi = async (shopId) => {
  const response = await axios.get(`${ORDER_API}/shop/info/ceo/${shopId}`, {
    headers: {Authorization: `Bearer ceo-${shopId}`}
  });
  return response.data;
}

// 행정동 조회
export const getDongApi = async (data) => {
  const response = await axios.get(`${BACK_OFFICE_API}/addrMgt`, {
    params: data
  })

  return response.data;
}


// 포스 채널 상위 상점 조회
export const getPostTopShopIdApi = async (shopId) => {
  const response = await axios.get(`${POS_API}/shop/v2/top-id`, {
    params: {
      shopIdList: shopId
    }
  });
  return response.data;
}

// 관리자 채널 주소 조회
export const getAdminAddrMgtApi = async (data) => {
  const response = await axios.get(`${BACK_OFFICE_API}/addrMgt`, {
    params: data
  });
  return response.data;
}

// 주문 채널 배달권역 조회
export const getOrderDeliverableAreaApi = async (shopId) => {
  const response = await axios.get(`${ORDER_API}/deliverable/area/ceo`, {
    params: {shopId: shopId},
    headers: { Authorization: `Bearer ceo` }
  });
  return response.data;
}



/**
 * 이하 함수는 서버 대상 식별 불가
 * 함수 내부 주석처리
 * 
 * @date 2026-04-17
 * @author Saccharin01
 */

// new 하위 상점 조회
export const getShopSimpleApi = async (accessToken) => {
  // const response = await axios.get(`${newTestApiUrl}/ceo/shops/simple`, {
  //   headers: {
  //     Authorization: `Bearer ${accessToken}`,
  //   },
  // });

  // return response.data;
};

// new 하위 상점 원산지 조회
export const getShopOriginApi = async (data) => {
  // const {accessToken} = getUserInfo();

  // const response = await axios.get(`${newTestApiUrl}/ceo/shops/country-of-origin`, {
  //   headers: {
  //     Authorization: `Bearer ${accessToken}`,
  //   },
  //   params: data
  // });

  // return response.data;
};

// new 상점 정보 조회
export const getShopInfoApi = async (normalShopId) => {
  // const {accessToken} = getUserInfo();

  // const response = await axios.get(`${newTestApiUrl}/ceo/shops/normal/${normalShopId}`, {
  //   headers: {Authorization: `Bearer ${accessToken}`,}
  // });

  // return response.data;
};

// new 상점 정보 수정
export const setShopInfoApi = async (data, normalShopId) => {
  // const {accessToken} = getUserInfo();

  // await axios.put(`${newTestApiUrl}/ceo/shops/normal/${normalShopId}`, data, {
  //   headers: {Authorization: `Bearer ${accessToken}`,}
  // });
};

// new 내 정보 조회
export const getMeInfoApi = async () => {
  // const {accessToken} = getUserInfo();

  // const response = await axios.get(`${newTestApiUrl}/ceo/shops/me`, {
  //   headers: {
  //     Authorization: `Bearer ${accessToken}`,
  //   }
  // });

  // return response.data;
};

// new 하위 상점 조회
export const getShopOperateApi = async (data) => {
  // const {accessToken} = getUserInfo();

  // const response = await axios.get(`${newTestApiUrl}/ceo/shops/operate`, {
  //   headers: {Authorization: `Bearer ${accessToken}`},
  //   params: data
  // });

  // return response.data;
}

// 상점 영업정지
export const getShopPauseApi = async () => {
  // const {accessToken} = getUserInfo();

  // const response = await axios.get(`${newTestApiUrl}/ceo/shops/pause`, {
  //   headers: {Authorization: `Bearer ${accessToken}`}
  // });
  // console.log(response);
  // return response.data;
}


// 상점 영업정지
export const setShopPauseApi = async (data) => {
  // const {accessToken} = getUserInfo();

  // await axios.post(`${newTestApiUrl}/ceo/shops/pause`, data, {
  //   headers: {Authorization: `Bearer ${accessToken}`}
  // });
}

export const getTestShopApi = async (shopId) => {
  const response = await axios.get(`${ORDER_API}/shop/info/ceo/${shopId}`, {
    headers: {Authorization: `Bearer ceo`}
  });

  return response.data;
};

// 상점 수정
export const setTestShopApi = async (shopId, data) => {
  await axios.put(`${ORDER_API}/shop/v2/${shopId}`, data);
}

// 주문금액별 배달비 조회
export const getTestOrderCostApi = async (shopId) => {
  const response = await axios.get(`${ORDER_API}/cost/delivery/order-cost`, {
    headers: {Authorization: `Bearer ceo`},
    params: {shopId: shopId}
  });

  return response.data;
};

export const setTestOrderCostApi = async (data) => {
  await axios.post(`${ORDER_API}/cost/delivery/order-cost`, data);
};
